import React, { useState, useEffect } from "react";
import { Loader, Pagination } from "semantic-ui-react";
import { map, size } from "lodash";
import { MozillaHubRoomsApi } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { RoomsItem } from "../RoomsItem";
import "./ListRooms.scss";

const roomsControllers = new MozillaHubRoomsApi();

export function ListRooms() {
  const { accessToken } = useAuth();

  const [rooms, setRooms] = useState(null);
  const [pagination, setPagination] = useState(null);
  const [page, setPage] = useState(1);
  const [reload, setReload] = useState(false);

  const onReload = () => setReload((prevState) => !prevState);

  useEffect(() => {
    (async () => {
      try {
        const response = await roomsControllers.getRooms(
          accessToken,
          page, // Asegúrate de pasar la página actual
          10, // Puedes ajustar el pageSize aquí o hacer que sea dinámico
        );
        //console.log("Rooms cargados para la página:", response.docs);

        // Verifica si la respuesta tiene los campos correctos
        setRooms(response.docs); // Asumiendo que 'docs' contiene la lista de rooms
        setPagination({
          total: response.totalDocs,
          limit: response.limit,
          page: response.page,
          pages: response.totalPages,
        });
      } catch (error) {
        console.log(error);
      }
    })();
  }, [accessToken, page, reload]);

  const changePage = (_, data) => {
    setPage(data.activePage);
  };

  if (!rooms) return <Loader active inline="centered" />;

  if (size(rooms) === 0) {
    return <h2>No emails found</h2>;
  }

  return (
    <div className="list-rooms">
      {map(rooms, (room) => (
        // console.log(email.email),
        <RoomsItem key={room.name} room={room} onReload={onReload} />
      ))}
      <div className="list-rooms__pagination">
        <Pagination
          defaultActivePage={page}
          totalPages={pagination.pages}
          ellipsisItem={false}
          firstItem={null}
          lastItem={null}
          onPageChange={changePage}
        />
      </div>
    </div>
  );
}
